import { RequestId } from './messenger';

export enum Messages {
	Get = 'widget-storage-get',
	Set = 'widget-storage-set',
	Remove = 'widget-storage-remove'
}

export enum IncommingMessages {
	GetResponse = 'widget-storage-get-response',
	SetResponse = 'widget-storage-set-response',
	RemoveResponse = 'widget-storage-remove-response'
}

export interface MessageParamsMap {
	[Messages.Get]: {
		requestId: RequestId;
		key?: string;
	};
	[Messages.Set]: {
		requestId: RequestId;
		data: Record<string, any>;
	};
	[Messages.Remove]: {
		requestId: RequestId;
		key: string;
	};
}

export interface IncommingMessageParamsMap {
	[IncommingMessages.GetResponse]: {
		requestId: RequestId;
		result: any;
	};
	[IncommingMessages.SetResponse]: {
		requestId: RequestId;
		result: boolean;
	};
	[IncommingMessages.RemoveResponse]: {
		requestId: RequestId;
		result: boolean;
	};
}
